import {Component, Input} from '@angular/core';
import {CoreService} from 'src/app/services/core.service';
import {environment} from "../../../../../environments/environment";

@Component({
    selector: 'app-branding',
    imports: [],
    template: `
        <a href="/" class="logodark">
            <img
                    src="{{environment.logoLight}}"
                    class="align-middle m-2"
                    alt="logo"
                    [style.width]="width + 'px'"
            />
        </a>

        <a href="/" class="logolight">
            <img
                    src="{{environment.logoDark}}"
                    class="align-middle m-2"
                    alt="logo"
                    [style.width]="width + 'px'"
            />
        </a>
    `,
    standalone: true
})
export class BrandingComponent {
  @Input() width: number = 200;
  options = this.settings.getOptions();

  constructor(private settings: CoreService) {
  }

  protected readonly environment = environment;
}
